// https://api.mapbox.com/geocoding/v5/mapbox.places/sdf.json?access_token=pk.eyJ1IjoiZnJvbW8iLCJhIjoiY2lxeWN1dDk4MDF0Y2Zza3FlOW03aG93ayJ9.vN4_HcG9if1Jb5-lm5K7Sw&country=us&bbox=-105.236864%2C38.555167%2C-104.119832%2C39.078587&limit=5
import {MAPBOX_TOKEN, URL_CONFIG} from "../config";
import {MAX_BOUNDS} from "../utils/maxBounds";
const bbox = [
    MAX_BOUNDS[0][0],
    MAX_BOUNDS[0][1],
    MAX_BOUNDS[1][0],
    MAX_BOUNDS[1][1]
].join(',');
export async function geocode (query: string) {
    try {
        const results = await google_geocode(query);
        // const results = await mapbox_geocode(query);
        return results;

    } catch (e) {
        const results = await mapbox_geocode(query);
        return results;
    }
}

async function mapbox_geocode (query: string) {
    const results = await fetch(createMapboxUrl({
        query,
        bbox
    })) as any;
    const {features = []} = await results.json();
    // console.log(results);
    return features.map((f: {place_name: string, text: string, center: number[]}) => ({
        text: f.place_name || f.text,
        lat: f.center[1],
        lon: f.center[0]
    }));
}

async function google_geocode (query: string) {
    const response = await fetch(createGoogleUrl({
        query,
        bbox
    }));
    const {results = []} = await response.json();
    return results.map((f: {formatted_address: string, geometry: {location: {lat: number, lng: number}}}) => ({
        text: f.formatted_address,
        lat: f.geometry.location.lat,
        lon: f.geometry.location.lng
    }));
}

function createMapboxUrl (search: {
    query: string;
    bbox: any;
    access_token?: string;
    country?: string;
    limit?: number;
}) {
    const {
        query,
        access_token = MAPBOX_TOKEN,
        country = 'us',
        bbox,
        limit = 5
    } = search;
    return `
        ${URL_CONFIG.mapboxGeocoderUrl}/${query}.json?access_token=${access_token}&country=${country}&bbox=${bbox}&limit=${limit}
    `;
};

// https://maps.googleapis.com/maps/api/geocode/json?address=1600+Amphitheatre+Parkway,+Mountain+View,+CA&key=AIzaSyCxZzhbTrwMvI3bz-YgIU_ZEU_3J5yYWvI

function createGoogleUrl (search: {
    query: string;
    bbox: any;
    access_token?: string;
    country?: string;
    limit?: number;
}) {
    const {
        query,
    } = search;
    const address = query.replace('/s', '+');

    const bounds = `${MAX_BOUNDS[1][0]},${MAX_BOUNDS[1][1]}|${MAX_BOUNDS[0][0]},${MAX_BOUNDS[0][1]}`;
    // &key=${APIKEY}
    return `
        ${URL_CONFIG.googleGeocoderUrl}?address=${address}&bounds=${bounds}
    `;
}
